import { useEffect, useState, useRef } from "react";
import { CheckCircleOutlined, CloseCircleOutlined } from "@ant-design/icons";
import { Table } from "antd";
import { useNavigate } from "react-router-dom";
import { getTablePagination } from "../../../utils/tablePagination";
import { getGlobalMedicationApi } from "../../../services/medication.services";
import { UiDataTable } from "../../ui";
import useQuery from "../../../hooks/useQuery";
import {
  updateUrlSearchParams,
  parsePageParam,
  parseSearchParam,
} from "../../../helpers/urlFilters";
import useIsMobile from "../../../hooks/useIsMobile";
import usePageFillTableScroll from "../../../hooks/usePageFillTableScroll";

const GlobalMedicationTable = () => {
  const navigate = useNavigate();
  const params = useQuery();
  const isMobile = useIsMobile();
  const tableWrapRef = useRef(null);
  const [data, setData] = useState([]);
  const [page, setPage] = useState(() => parsePageParam(params));
  const [loading, setLoading] = useState(false);
  const [searchQuery, setSearchQuery] = useState(() => parseSearchParam(params));
  const tableScroll = usePageFillTableScroll(
    tableWrapRef,
    isMobile,
    "default",
    data?.data?.length ?? 0
  );
  useEffect(() => {
    let queryParams = { page: page, limit: 100 };
    if (searchQuery) {
      queryParams.search = searchQuery;
      queryParams.page = 1;
    }
    const queryString = new URLSearchParams(queryParams);
    setLoading(true);
    getGlobalMedicationApi(queryString)
      .then((res) => {
        setData(res?.data);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  }, [page, searchQuery]);
  const columns = [
    {
      title: "Medicine",
      key: "name",
      dataIndex: "name",
      sorter: (a, b) => a?.name.localeCompare(b?.name),
    },
    {
      title: "Drug 1 Name",
      key: "drug1_name",
      dataIndex: "drug1_name",
      render: (value) => (value ? value : "-"),
      sorter: (a, b) => {
        const descA = a?.drug1_name || "";
        const descB = b?.drug1_name || "";
        return descA?.localeCompare?.(descB);
      },
    },
    {
      title: "Drug 2 Name",
      key: "drug2_name",
      dataIndex: "drug2_name",
      render: (value) => (value ? value : "-"),
      sorter: (a, b) => {
        const descA = a?.drug2_name || "";
        const descB = b?.drug2_name || "";
        return descA?.localeCompare?.(descB);
      },
    },
    // {
    //   title: "Description",
    //   dataIndex: "description",
    //   editable: true,
    //   width: "20%",
    //   render: (value) => (
    //     <Paragraph
    //       ellipsis={{
    //         rows: 2,
    //         expandable: true,
    //         symbol: "more",
    //       }}
    //       style={{ width: 400 }}
    //     >
    //       {value}
    //     </Paragraph>
    //   ),
    // },
    {
      title: "Is antibiotic",
      dataIndex: "is_antiboitic",
      editable: true,
      width: "10%",
      render: (value) =>
        value ? (
          <CheckCircleOutlined style={{ color: "green", fontSize: "18px" }} />
        ) : (
          <CloseCircleOutlined style={{ color: "red", fontSize: "18px" }} />
        ),
    },
  ];
  const onMedSearch = (value) => {
    const query = value?.target?.value;
    setSearchQuery(query || null);
    setPage(1);
    updateUrlSearchParams(navigate, { search: query || null, page: null });
  };

  const handlePageChange = (value) => {
    setPage(value);
    updateUrlSearchParams(navigate, { page: value === 1 ? null : value });
  };
  return (
    <UiDataTable
      showHeader={false}
      shellClassName="ui-table-fill-shell"
      onSearch={(e) => onMedSearch(e)}
      searchPlaceholder="Search medicines"
    >
      <div ref={tableWrapRef} className="ui-table-fill-body">
        <Table
          className="no-vertical-borders"
          dataSource={data?.data}
          columns={columns}
          pagination={getTablePagination({
            current: page,
            pageSize: 100,
            total: data?.total_count ?? 0,
            onChange: handlePageChange,
          })}
          loading={loading}
          bordered
          scroll={tableScroll}
        />
      </div>
    </UiDataTable>
  );
};

export default GlobalMedicationTable;
